<template>
  <div class="user-flashcards">
    <flashcards-actions
      v-if="showActions"
      @selectSide="onSelectSide"
      @shuffle="onShuffle"/>
    <flashcards-player
      :frontFirst="frontFirst"
      :shuffleOn="shuffleOn"
      :cards="deck.cards" />
  </div>
</template>

<script>
import FlashcardsActions from './flashcards_actions'
import FlashcardsPlayer from './flashcards_player'

export default {
  data() {
    return {
      frontFirst: true,
      shuffleOn: false
    }
  },

  components: {
    FlashcardsActions,
    FlashcardsPlayer
  },

  props: {
    deck: {
      type: Object,
      required: true
    },
    showActions: {
      type: Boolean
    }
  },

  methods: {
    onSelectSide(side) {
      this.frontFirst = side.frontSide
    },
    onShuffle(shuffle) {
      this.shuffleOn = shuffle.shuffle
    }
  }
}
</script>
